import React from 'react';
import { PropTypes } from 'prop-types';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import Steps, { Step } from '../../common_components/steps/Index';
import { Button, Popover } from 'react-bootstrap';
import '../../common_components/steps/style';
import './Stages.scss';

import { BMC_STAGES, BMC_STAGES_TO_INTEGER } from './bmc_constants';
import { isSmallWindows } from '../functions';

@injectIntl
@observer
export default class Stages extends React.Component {
  constructor(props) {
    super(props);

    this.state = { smallWindow: isSmallWindows() };
  }

  componentDidMount() {
    window.addEventListener('resize', () => {
      this.setState({ smallWindow: isSmallWindows() });
    });
  }

  render() {
    const { current, secondaryCurrent, intl } = this.props;
    const labelPlacement = this.state.smallWindow ? ' ' : 'vertical';
    const direction = this.state.smallWindow ? 'vertical' : 'horizontal';
    return (
      <div className="bmc-stages-container">
        <Steps
          labelPlacement={labelPlacement}
          direction={direction}
          current={BMC_STAGES_TO_INTEGER[current]}
          secondaryCurrent={BMC_STAGES_TO_INTEGER[secondaryCurrent]}
        >
          {Object.keys(BMC_STAGES).map((key, index) => {
            return this.renderStep(BMC_STAGES[key]);
          })}
        </Steps>
      </div>
    );
  }

  renderStep(stage) {
    let shouldEmphasize = false;
    try {
      shouldEmphasize = this.props.emphasizedSteps.includes(stage);
    } catch (err) {
      console.log('Err shouldEmphasize');
    }
    /*
    console.group();
    console.log('Stage:', stage);
    console.log('Can unmark stage: ', this.props.canUnmarkStage(stage));
    console.groupEnd();
    */
    const showPopover =
      this.props.canUnmarkStage &&
      this.props.canUnmarkStage(stage) &&
      BMC_STAGES.OBSERVATIONAL !== stage;

    const popover = showPopover && (
      <Popover id={`${stage}-popover`}>
        <div style={{ padding: '5px' }}>
          <div style={{ marginBottom: '10px' }}>
            {this.props.intl.formatMessage({ id: 'unmark_stage_message' })}
          </div>
          <Button
            bsStyle={'primary'}
            block
            onClick={() => this.props.onUnmarkStage(stage)}
          >
            {this.props.intl.formatMessage({ id: 'unmark_stage_button' })}
          </Button>
        </div>
      </Popover>
    );

    const { stagesMvp } = this.props;

    return (
      <Step
        className={
          `stage-item-${stage} ` + (shouldEmphasize ? 'emphasized-step' : '')
        }
        title={this.props.intl.formatMessage({ id: stage })}
        onClick={() =>
          this.props.onStageClick(stage, stagesMvp && stagesMvp[stage])
        }
        key={`key-${stage}`}
        upperTitle={this.getUpperTitle(stage)}
        {...(popover ? { popover } : {})}
      />
    );
  }

  getUpperTitle(stage) {
    const { stagesMvp } = this.props;

    if (stagesMvp && stagesMvp[stage]) {
      return stagesMvp[stage].mvpName;
    }

    return undefined;
  }
}

Stages.propTypes = {
  current: PropTypes.string,
  secondaryCurrent: PropTypes.string,
  stagesMvp: PropTypes.object,
  atBmcVision: PropTypes.bool,
  onStageClick: PropTypes.func
};
